import { css, FlattenSimpleInterpolation } from 'styled-components';

// Import types
import { FormGridConfig } from 'types/views/form';

export const generateResponsiveGrid = (gridConfig?: FormGridConfig, customStyles?: FlattenSimpleInterpolation): FlattenSimpleInterpolation[] => {
	const styles: FlattenSimpleInterpolation[] = [];

	if (!gridConfig) {
		styles.push(css`
			grid-column: span 16;
		`);
	} else {
		Object.keys(gridConfig).forEach((breakpoint) => {
			const columns = gridConfig[Number(breakpoint)];
			styles.push(css`
				@media (min-width: ${breakpoint}px) {
					grid-column: span ${columns};
				}
			`);
		});
	}

	if (customStyles) {
		styles.push(customStyles);
	}

	return styles;
};
